<template>
    <div class="box-width">
        <div class="campaign-picture rounded-10" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
        <div class="text-14 md:text-16 text-a-brown-502314 p-2">{{campaign.name}}</div>
    </div>
</template>
<script>
export default {
    props: {
        campaign: { type: Object, required: true },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";

    .box-width {
        width: 156px;

        @include md-screen {
            width: 261px;
        }
    }
    .campaign-picture {
        width: 156px;
        height: 104px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position-x: center;
        background-position-y: center;

        @include md-screen {
            width: 261px;
            height: 174px;
        }
    }
</style>
